import axios from 'axios';

import { getAuthorizationHeader } from '../utils/getAuthHeader';

const API_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:8081'}`;

const url = `${API_URL}/tags`;

export const fetchAllTags = async () => {
  const result = await axios.get(url, {
    headers: getAuthorizationHeader(),
  });
  return result.data;
};
export const fetchTagsByDepartments = async (ids) => {
  const result = await axios.post(`${url}/by-departments`, ids, {
    headers: getAuthorizationHeader(),
  });
  return result.data;
};

export const fetchTagsByCreatedBy = async (id) => {
  const result = await axios.get(`${url}/by-user/${id}`, {
    headers: getAuthorizationHeader(),
  });
  return result.data;
};

export const fetchTagsByDepartment = async (id) => {
  const result = await axios.get(`${url}/by-department/${id}`, {
    headers: getAuthorizationHeader(),
  });
  return result.data;
};

export const addTags = async (data) => {
  const result = await axios.post(url, data, {
    headers: getAuthorizationHeader(),
  });
  return result.data;
};

export const updateTags = async (id, data) => {
  const result = await axios.put(`${url}/${id}`, data, {
    headers: getAuthorizationHeader(),
  });
  return result.data;
};

export const deleteMultipleTags = async (ids, isConfirmedDelete = false) => {
  const queryString = ids.map((id) => `ids=${id}`).join('&');
  const result = await axios.delete(
    `${url}/delete-multiple?${queryString}&isConfirmedDelete=${isConfirmedDelete}`,
    {
      headers: getAuthorizationHeader(),
    }
  );
  return result.data;
};

export const deleteTag = async (id, isConfirmedDelete = false) => {
  const result = await axios.delete(
    `${url}/${id}?isConfirmedDelete=${isConfirmedDelete}`,
    {
      headers: getAuthorizationHeader(),
    }
  );
  return result.data;
};
